<template>
  <div>
    <div
      v-if="!hideHeader"
      class="d-flex justify-space-between align-center mb-4 gap-2"
    >
      <h6 class="mb-0">{{ precification.name }}</h6>
      <v-spacer />
      <v-btn icon small @click="$emit('copy', precification)">
        <v-icon small>mdi-content-copy</v-icon>
      </v-btn>
      <v-chip
        label
        small
        :color="precification.isActive ? 'success' : 'secondary'"
      >
        {{ precification.isActive ? "Ativa" : "Inativa" }}
      </v-chip>
    </div>
    <v-card
      outlined
      class="d-flex justify-space-between align-center pa-2 px-6"
    >
      <div class="d-flex flex-column align-center">
        <p class="mb-0">Dia Validade</p>
        <p class="mb-0 font-weight-bold">{{ precification.dueDay }}</p>
      </div>
      <div class="d-flex flex-column align-center">
        <p class="mb-0">Multa</p>
        <p class="mb-0 font-weight-bold">{{ precification.finePercentage }}%</p>
      </div>
      <div class="d-flex flex-column align-center">
        <p class="mb-0">Juros</p>
        <p class="mb-0 font-weight-bold">
          {{ precification.interestPercentage }}%
        </p>
      </div>
    </v-card>
    <v-row no-gutters class="mx-0 mt-4">
      <v-col
        v-for="rule in precification.Rules"
        :key="rule.id"
        cols="12"
        md="6"
      >
        <v-list-item dense>
          <v-list-item-icon class="mr-4 d-flex align-center gap-1">
            <v-icon>{{
              INVOICE_DEFINITIONS.itemGroups[
                INVOICE_DEFINITIONS.itemKey[rule.itemKey]?.group
              ]?.icon
            }}</v-icon>
            <v-icon>{{
              INVOICE_DEFINITIONS.itemKey[rule.itemKey]?.icon
            }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ INVOICE_DEFINITIONS.itemKey[rule.itemKey]?.label }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ INVOICE_DEFINITIONS.pricingTypes[rule.pricingType]?.label }}
              •
              {{
                INVOICE_DEFINITIONS.pricingTypes[rule.pricingType]?.formatter(
                  rule.config,
                  rule.itemKey
                )
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import INVOICE_DEFINITIONS from "@/definitions/InvoiceDefinitions";

export default {
  name: "PrecificationDetails",
  data() {
    return {
      INVOICE_DEFINITIONS,
    };
  },
  props: {
    precification: {
      type: Object,
      required: true,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
